import React from 'react'

export default ({ videoId, autoplay }) => {
  const autoplayParam = !!autoplay ? 1 : 0
  const src =
    `https://player.vimeo.com/video/${videoId}` +
    `?title=0&byline=0&portrait=0&autoplay=${autoplayParam}` +
    '&quality=720p'

  return (
    <div className="vimeo-player">
      <iframe
        src={src}
        width="640"
        height="360"
        allowFullScreen
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/partials/vimeo-player.js